import config from './settingsConfig.json';
import { FAQ_LINKS } from '../faq';

// Derive the FAQ setting options straight from the FAQ page source list so the
// dropdowns can never drift from what actually renders on /dashboard/faq.
// Every built-in entry carries an id, so every one is both hideable and
// overridable; `link` rides along so the override editor can show each entry's
// built-in URL as its placeholder.
const FAQ_OPTIONS = FAQ_LINKS.map(f => ({ label: f.title, value: f.id, link: f.link }));

const DERIVED_OPTIONS = {
  'faq.hide': FAQ_OPTIONS,
  'faq.overrides': FAQ_OPTIONS,
};

export const SETTINGS_SCHEMA = config.settings.map(s =>
  DERIVED_OPTIONS[s.key] ? { ...s, options: DERIVED_OPTIONS[s.key] } : s
);

export const CATEGORIES = config.categories;

const schemaMap = {};
SETTINGS_SCHEMA.forEach(s => { schemaMap[s.key] = s; });

export const getSchemaByKey = (key) => schemaMap[key];

export const getSchemaKeys = () => new Set(SETTINGS_SCHEMA.map(s => s.key));
